import { render, staticRenderFns } from "./areaModal.vue?vue&type=template&id=050746e3&scoped=true"
import script from "./areaModal.vue?vue&type=script&lang=js"
export * from "./areaModal.vue?vue&type=script&lang=js"
import style0 from "./areaModal.vue?vue&type=style&index=0&id=050746e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050746e3",
  null
  
)

export default component.exports